import { Options, Vue } from "vue-class-component";

@Options({
    name: "delete-icon",
})
export default class DeleteIcon extends Vue {
}
